import { render, staticRenderFns } from "./RankForm.vue?vue&type=template&id=3ff7ecd0&scoped=true&"
import script from "./RankForm.vue?vue&type=script&lang=js&"
export * from "./RankForm.vue?vue&type=script&lang=js&"
import style0 from "./RankForm.vue?vue&type=style&index=0&id=3ff7ecd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7ecd0",
  null
  
)

export default component.exports